module.exports = __webpack_public_path__ + "static/img/success3.803344e5.png";